<script setup lang="ts">
import { provide } from 'vue';

import { fieldGroupInjectionKey } from '#ui/composables/useFieldGroup';

/**
 * Component used for _undoing_ a field group in nested components.
 */

provide(fieldGroupInjectionKey, undefined as any);
</script>

<template>
	<slot />
</template>
